import Client from '@/classes/Api/Client';

const state = {
  requests: [],
  pagination: {},
};

const getters = {};

const mutations = {
  setRequests(state, data) {
    state.requests = data;
  },
  setPagination(state, data) {
    state.pagination = data;
  },
};

const actions = {
  load({commit}, page) {
    return Client.getDictionaryRequestList(page).then((response) => {
      commit('setRequests', response.data.data);
      commit('setPagination', response.data.paginate);
    });
  },

  loadForOperator({commit}, filter) {
    return Client.getOperatorDictionaryRequestList(filter).then((response) => {
      commit('setRequests', response.data.data);
      commit('setPagination', response.data.paginate);
    });
  },

  clear({commit}) {
    commit('setRequests', []);
    commit('setPagination', {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
